<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="form-group col-4">
        <div class="input-group">
          <span class="input-group-text">Enter VIN</span>
          <input v-model="vin" class="form-control" />
          <button class="btn btn-primary" @click="decodeTheVin">VIN Decode</button>
          <button v-show="isShow" class="btn btn-primary" style="margin-left: 1px" @click="compareResults">Query</button>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-6 custom-json-wrapper">
        <div v-show="loading?.decodedVin" class="custom-loading">
          <i class="fas fa-spinner fa-spin"></i>
          <span>Loading...</span>
        </div>
        <json-viewer v-show="isShow" :value="decodedVin" copyable />
      </div>
    </div>
    <dialog-vin-decode-compare v-model="actionCompare" @closing="closeModal" />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import DialogVinDecodeCompare from './dialog-vin-decode-compare.vue'
import { JsonViewer } from 'vue3-json-viewer'
import 'vue3-json-viewer/dist/index.css'
export default {
  name: 'VinDecode',
  components: {
    DialogVinDecodeCompare,
    JsonViewer
  },
  data() {
    return {
      vin: '',
      isNeo: false,
      actionCompare: null
    }
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'decodedVin', 'decodedAltVin']),
    isShow() {
      let _is = false
      if (this.decodedVin !== undefined && this.decodedVin !== null) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['decodeVin']),
    closeModal() {
      this.actionCompare = null
    },
    async decodeTheVin() {
      this.isNeo = false
      if (this.vin !== '') {
        await this.decodeVin(this.vin)
      }
    },
    compareResults() {
      this.actionCompare = true
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  margin-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
}
.custom-json-wrapper {
  max-height: 525px;
  overflow: auto;
}
</style>
